import axios from "axios";

const prod = process.env.NODE_ENV === "production";

const axiosConfig = axios.create({
    baseURL: prod ? "/api" : "http://localhost:3001/api", // change url when deployed
    withCredentials: true,
});

axiosConfig.interceptors.response.use(
    (response) => response,
    (error) => {
        console.error("Error getting data: ", error);
        return Promise.reject(error);
    }
);

export default axiosConfig;